import React from 'react';
import { Package } from 'lucide-react';

const Bundles = () => (
  <div>
    <div className="mb-8">
      <h1 className="text-2xl font-bold text-white tracking-tight">Bundles</h1>
      <p className="text-sm text-gray-500 mt-1">Manage app rating bundles</p>
    </div>

    <div className="flex flex-col items-center justify-center py-24 rounded-2xl border border-white/8 bg-[#0d1526]/40">
      <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-4">
        <Package size={24} className="text-gray-600" />
      </div>
      <p className="text-white font-semibold text-base mb-1">Coming Soon</p>
      <p className="text-gray-600 text-sm">Bundle management will be available here.</p>
    </div>
  </div>
);

export default Bundles;
